export const getAddJobOrderReducer = (state = {}, action) => {
  switch (action.type) {
    case "ADD_JOBORDER_REQUEST":
      return {
        loading: true,
        ...state,
      };
    case "ADD_JOBORDER_SUCCESS":
      return {
        loading: false,
        success: true,
      };
    case "ADD_JOBORDER_FAILED":
      return {
        loading: false,
        error: action.payload,
      };

    case "ALL_JOBORDER_CLEAR":
      return {
        loading: false,
        success: false,
      };

    default:
      return state;
  }
};

export const getAllJobOrderReducer = (state = { joborder: [] }, action) => {
  switch (action.type) {
    case "GET_JOBORDER_REQUEST":
      return {
        loading: true,
        ...state,
      };
    case "GET_JOBORDER_SUCCESS":
      return {
        loading: false,
        joborder: action.payload,
      };
    case "GET_JOBORDER_FAILED":
      return {
        loading: false,
        error: action.payload,
      };
    default:
      return state;
  }
};
